import { HeaderText } from "@src/components/general/HeaderText";
import { Text } from "@src/components/general/Text";
import { VerticalFlexbox } from "@src/components/layout/Flexbox";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@src/components/ui/card";
import { UserCircle } from "lucide-react";

export const AccountPage = () => {
  return (
    <VerticalFlexbox gap="md" className="w-full px-4 py-6 md:px-8 md:py-8">
      <VerticalFlexbox gap="xs">
        <Text
          sizing="sm"
          fontWeight={500}
          appearance="subdued"
          className="uppercase tracking-widest"
        >
          Account
        </Text>
        <HeaderText tag="h1">Account settings</HeaderText>
      </VerticalFlexbox>
      <Card className="max-w-xl">
        <CardHeader>
          <VerticalFlexbox
            alignItems="center"
            justifyContent="center"
            className="mb-2 size-10 rounded-lg bg-muted text-muted-foreground"
          >
            <UserCircle className="size-5" />
          </VerticalFlexbox>
          <CardTitle>Coming soon</CardTitle>
          <CardDescription>
            Profile, security, and notification preferences will live here.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Text sizing="sm" appearance="subdued">
            We're building out account management. Check back soon.
          </Text>
        </CardContent>
      </Card>
    </VerticalFlexbox>
  );
};
